import React from "react";
import Product from "./Product";
import banner_home from "./Assets/banner_home.jpg";
import harrypotter from "./Assets/harrypotter.jpg";
import laptop from "./Assets/laptop.jpg";
import amazonecho from "./Assets/amazonecho.jpg";
import furniture from "./Assets/furniture.jpg";
import washingmachine from "./Assets/washingmachine.jpg";
import television from "./Assets/television.jpg";
import "./Home.css";
function Home() {
  return (
    <div className="home">
      <div className="home_container">
        <img className="home_image" src={banner_home}></img>

        <div className="home_row">
          <Product
            id={1024}
            title="Harry Potter Box Set: The Complete Collection (Children’s Hardback)
          (Set of 7 Volumes) Hardcover – Box set, 17 December 2014"
            price="498.65"
            image={harrypotter}
            rating={5}
          ></Product>
          <Product
            id={2051}
            title="HP Omen 15.6-inch FHD Gaming Laptop (Ryzen 5-4600H/8GB/512GB SSD/Windows 10/NVIDIA GTX 1650ti 4GB/Shadow Black/2.36 kg), 15-en0001AX4"
            price="69,990.00"
            image={laptop}
            rating={4}
          ></Product>
        </div>
        <div className="home_row">
          <Product
            id={2058}
            title="All-new Echo Dot (4th Gen) | Next generation smart speaker with improved bass and Alexa (Blue)"
            price="3,499.00"
            image={amazonecho}
            rating={4}
          ></Product>
          <Product
            id={9096}
            title="Amazon Brand - Solimo Polaris Engineered Wood Oak Finish Queen Bed with Box Storage (Imperial Teak)"
            price="13,999.00"
            image={furniture}
            rating={3}
          ></Product>
          <Product
            id={8058}
            title="Samsung 6.0 Kg Inverter 5 Star Fully-Automatic Front Loading Washing Machine (WW60R20GLMA/TL, White, Hygiene Steam)"
            price="21,990.00"
            image={washingmachine}
            rating={4}
          ></Product>
        </div>
        <div className="home_row">
          <Product
            id={6589}
            title="Samsung 6.0 Kg Inverter 5 Star Fully-Automatic Front Loading Washing Machine (WW60R20GLMA/TL, White, Hygiene Steam)"
            price="21,990.00"
            image={television}
            rating={4}
          ></Product>
        </div>
      </div>
    </div>
  );
}

export default Home;
